import { environment } from '../../environment';
import { IntegrationDefaultEnum } from '../../types';

export const isWisniowski = environment.INTEGRATION_DEFAULT === IntegrationDefaultEnum.Wisniowski;
